import { render, staticRenderFns } from "./StockingsPage.vue?vue&type=template&id=2b0b20ee&scoped=true"
import script from "./StockingsPage.vue?vue&type=script&lang=js"
export * from "./StockingsPage.vue?vue&type=script&lang=js"
import style0 from "./StockingsPage.vue?vue&type=style&index=0&id=2b0b20ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b20ee",
  null
  
)

export default component.exports